<div id="fuse-shortcuts" #shortcuts>

    <div class="shortcuts-mobile-toggle" *ngIf="!mobileShortcutsPanelActive" fxLayout="row" fxLayoutAlign="start center"
        fxHide fxShow.lt-md>
        <button mat-icon-button (click)="showMobileShortcutsPanel()">
            <mat-icon class="amber-600-fg">star</mat-icon>
        </button>
    </div>

    <div class="shortcuts" fxLayout="row" fxHide fxShow.gt-sm>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">

            <div fxLayout="row" fxLayoutAlign="start center">

                <div class="w-40 h-40 p-4" fxLayout="row" fxLayoutAlign="center center">

                    <a mat-icon-button matTooltip="Tela inicial" routerLink="/aplicacao/inicio">
                        <mat-icon class="secondary-text">home</mat-icon>
                    </a>

                </div>

                <div class="w-40 h-40 p-4" fxLayout="row" fxLayoutAlign="center center"
                    *ngFor="let shortcutItem of shortcutItems">

                    <a mat-icon-button matTooltip="{{shortcutItem.title}}" [routerLink]="shortcutItem.url">
                        <mat-icon class="secondary-text" *ngIf="shortcutItem.icon">{{shortcutItem.icon}}</mat-icon>
                        <span *ngIf="!shortcutItem.icon" class="h2 secondary-text text-bold">
                            {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                        </span>
                    </a>

                </div>

                <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="Adicionar ou remover atalhos"
                    (menuOpened)="onMenuOpen()">
                    <mat-icon class="amber-600-fg">star</mat-icon>
                </button>

                <button mat-icon-button style="color: rgb(45, 97, 99);" matTooltip="Informações"
                    (click)="generalInformation()">
                    <mat-icon>info</mat-icon>
                </button>

                <button  *ngIf="showPendingPayments" mat-icon-button [style.color]="orderPayPendingList?.length ? 'rgb(255, 1, 1)' : 'green'"
                    [matTooltip]="orderPayPendingList?.length ? 'Há pagamentos pendentes' : 'Não há pagamentos pendentes!'"
                    (click)="openPayPending()">

                    <mat-icon>money_off</mat-icon>
                </button>


                <cwg-totem-notify *ngIf="showTotem"></cwg-totem-notify>

                <div *ngIf="!isConnected" class="alert alert-danger" style="color: red;">
                    Conexão com o servidor perdida! <mat-icon>signal_wifi_off</mat-icon>
                </div>

                <!--<img *ngIf="latency <= 35 && isConnected" title="Sinal Excelente" style="width: 24px; height: 24px;"
                    src="assets/icons/wifi3.svg">
                <img *ngIf="latency > 35 && latency <= 200 && isConnected" title="Sinal Bom" style="width: 24px; height: 24px;"
                    src="assets/icons/wifi4.svg">
                <img *ngIf="latency > 200 && latency <= 300 && isConnected" title="Sinal Mediano" style="width: 24px; height: 24px;"
                    src="assets/icons/wifi2.svg">
                <img *ngIf="latency > 300 && isConnected"  title="Sinal Fraco" style="width: 24px; height: 24px;"
                    src="assets/icons/wifi1.svg"> -->


            </div>

            <div class="shortcuts-mobile-close" fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.lt-md>
                <button mat-icon-button (click)="hideMobileShortcutsPanel()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

        </div>

        <mat-menu #addMenu="matMenu" class="w-240">

            <mat-form-field class="px-16 w-100-p" (click)="$event.stopPropagation()" floatLabel="never">
                <input #searchInput matInput placeholder="Pesquisar uma página" (input)="search($event)">
            </mat-form-field>

            <mat-divider></mat-divider>

            <mat-nav-list *ngIf="!searching" style="max-height: 312px; overflow: auto" fusePerfectScrollbar>

                <mat-list-item *ngFor="let shortcutItem of shortcutItems"
                    (click)="toggleShortcut($event, shortcutItem)">

                    <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">

                        <mat-icon mat-list-icon class="mr-8 secondary-text" *ngIf="shortcutItem.icon">
                            {{shortcutItem.icon}}
                        </mat-icon>

                        <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                            fxLayoutAlign="center center" *ngIf="!shortcutItem.icon">
                            {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                        </span>

                        <p matLine fxFlex>{{shortcutItem.title}}</p>

                        <mat-icon class="ml-8 amber-fg">star</mat-icon>

                    </div>

                </mat-list-item>

                <mat-list-item *ngIf="shortcutItems.length === 0">
                    <p>
                        <small>No shortcuts yet!</small>
                    </p>
                </mat-list-item>

            </mat-nav-list>

            <mat-nav-list *ngIf="searching" style="max-height: 312px; overflow: auto" fusePerfectScrollbar>

                <mat-list-item *ngFor="let navigationItem of filteredNavigationItems"
                    (click)="toggleShortcut($event, navigationItem)">

                    <div class="w-100-p" fxLayout="row" fxLayoutAlign="start center">

                        <mat-icon mat-list-icon class="mr-8 secondary-text" *ngIf="navigationItem.icon">
                            {{navigationItem.icon}}
                        </mat-icon>

                        <span class="h2 w-32 h-32 p-4 mr-8 secondary-text text-bold" fxLayout="row"
                            fxLayoutAlign="center center" *ngIf="!navigationItem.icon">
                            {{navigationItem.title.substr(0, 1).toUpperCase()}}
                        </span>

                        <p matLine fxFlex>{{navigationItem.title}}</p>

                        <mat-icon class="ml-8 amber-fg" *ngIf="isInShortcuts(navigationItem)">star</mat-icon>

                    </div>

                </mat-list-item>

            </mat-nav-list>

        </mat-menu>

    </div>

</div>
